/**
 * fadeInUp dùng chung cho nội dung text — opt-in qua attribute `data-reveal`.
 *
 * Cách dùng trong .twig, gắn vào bất kỳ thẻ nào muốn hiệu ứng (p, h2, li, div nội dung module...):
 *   <p data-reveal>...</p>
 *   <h2 data-reveal data-reveal-delay="0.15">...</h2>
 *   <li data-reveal data-reveal-distance="20">...</li>
 *
 * Nếu phần tử gắn `data-reveal` còn chứa thẻ con dạng nội dung (p, h1-h6, li, blockquote,
 * figure, table, dt, dd, div) — ví dụ bọc quanh 1 khối nội dung CMS render từ WYSIWYG như
 * `<div class="cms-content" data-reveal>{{ content|raw }}</div>` — hiệu ứng sẽ áp dụng cho
 * TỪNG thẻ con đó thay vì cả khối cha. Chỉ lấy thẻ con SÂU NHẤT (bỏ thẻ bọc ngoài nếu bên trong
 * còn thẻ nội dung khác) để 1 đoạn text không bị animate chồng 2 lần (transform cộng dồn → giật).
 * Các thẻ con kế thừa data-reveal-delay/-distance/-once từ thẻ data-reveal gần nhất.
 *
 * Trình tự (chống "giựt"):
 * 1. DOMContentLoaded — lúc preloader còn che: ẩn sẵn mọi phần tử (opacity 0 + lệch Y).
 * 2. Sau `qh:page-reveal` (xem main.js): phần tử vào khung nhìn (top 88%) mới animate TỚI trạng
 *    thái hiện (gsap.to). Trước đây dùng gsap.from lúc chạm mốc → phần tử đang hiện bị giật về
 *    opacity 0 rồi mới hiện lại.
 * - Nhiều phần tử cùng vào khung nhìn hiện LẦN LƯỢT theo thứ tự DOM (ScrollTrigger.batch + stagger).
 * - Phần tử ở cuối trang không bao giờ chạm được mốc 88% → tự hiện khi cuộn tới đáy trang.
 * - data-reveal-once="false": cuộn ngược lên trên phần tử thì ẩn lại, cuộn xuống chạy lại.
 * - Tôn trọng prefers-reduced-motion và trường hợp thiếu GSAP (không ẩn gì, nội dung hiện ngay).
 */
/**
 * Dùng chung cho các hiệu ứng reveal bên dưới: phần tử đã nằm HẲN phía trên khung nhìn thì hiện ngay
 * (gsap.set với `visibleVars`), trả về các phần tử còn lại để animate.
 *
 * Lý do: reload trang khi đang đứng giữa trang → trình duyệt khôi phục vị trí cuộn, lúc tạo
 * ScrollTrigger thì MỌI phần tử phía trên cũng đã qua mốc start nên bắn onEnter cùng 1 lượt với phần
 * tử đang hiển thị. ScrollTrigger.batch gộp tất cả vào 1 tween stagger theo thứ tự DOM → phần tử
 * trong khung nhìn đứng cuối hàng đợi, phải chờ (số phần tử phía trên × stagger) giây mới bắt đầu
 * chạy, còn hiệu ứng của các phần tử phía trên thì chạy "vô hình" ngoài màn hình.
 */
window.qhRevealPassed = function (elements, visibleVars) {
    var passed = elements.filter(function (el) {
        return el.getBoundingClientRect().bottom <= 0;
    });

    if (!passed.length) {
        return elements;
    }

    visibleVars.overwrite = 'auto';
    gsap.set(passed, visibleVars);

    return elements.filter(function (el) {
        return passed.indexOf(el) === -1;
    });
};

(function () {
    var CONTENT_SELECTOR = 'p, h1, h2, h3, h4, h5, h6, li, blockquote, figure, table, dt, dd, div';
    var START = 'top 88%';
    var DURATION = .7;
    var STAGGER = .15; // khoảng cách giữa mỗi phần tử khi nhiều phần tử vào khung nhìn cùng lúc

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canAnimate = !reduceMotion && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';

    var targets = [];

    // Đọc attribute ngay trên chính phần tử, nếu không có thì lấy từ thẻ data-reveal gần nhất
    // bao ngoài nó (để thẻ con nội dung CMS kế thừa cấu hình từ khối cha).
    function attrOf(el, name) {
        var own = el.getAttribute(name);

        if (own !== null) {
            return own;
        }

        var root = el.closest('[data-reveal]');
        return root ? root.getAttribute(name) : null;
    }

    function distanceOf(el) {
        var distance = parseFloat(attrOf(el, 'data-reveal-distance'));
        return isNaN(distance) ? 32 : distance;
    }

    function delayOf(el) {
        return parseFloat(attrOf(el, 'data-reveal-delay')) || 0;
    }

    function isRepeatable(el) {
        return attrOf(el, 'data-reveal-once') === 'false';
    }

    function collect() {
        var set = new Set();

        document.querySelectorAll('[data-reveal]').forEach(function (root) {
            var children = root.querySelectorAll(CONTENT_SELECTOR);

            if (children.length) {
                children.forEach(function (child) {
                    set.add(child);
                });
            } else {
                set.add(root);
            }
        });

        var list = Array.from(set);

        // Bỏ phần tử còn chứa phần tử khác trong danh sách (giữ thẻ sâu nhất) → không animate lồng nhau.
        list = list.filter(function (el) {
            return !list.some(function (other) {
                return other !== el && el.contains(other);
            });
        });

        // Set có thể không theo thứ tự DOM khi root lồng nhau → sắp lại để stagger đúng thứ tự.
        return list.sort(function (a, b) {
            return (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
        });
    }

    function hide(el) {
        el.qhRevealed = false;
        gsap.set(el, { opacity: 0, y: distanceOf(el) });
    }

    function show(elements) {
        elements = elements.filter(function (el) {
            return !el.qhRevealed;
        });

        if (!elements.length) {
            return;
        }

        elements.forEach(function (el) {
            el.qhRevealed = true;
        });

        elements = window.qhRevealPassed(elements, { opacity: 1, clearProps: 'transform' });

        if (!elements.length) {
            return;
        }

        gsap.to(elements, {
            opacity: 1,
            y: 0,
            delay: function (i, target) { return delayOf(target); },
            duration: DURATION,
            ease: 'power2.out',
            stagger: STAGGER,
            overwrite: 'auto', // chỉ huỷ tween trùng thuộc tính — true sẽ xoá cả tween khác (VD qhScrollRotate)
            clearProps: 'transform' // trả lại transform gốc của CSS sau khi xong
        });
    }

    // Bước 1 — ẩn sẵn khi DOM sẵn sàng (preloader vẫn đang che nên người dùng không thấy).
    function prepare() {
        if (!canAnimate) {
            return;
        }

        targets = collect();
        targets.forEach(hide);
    }

    // Bước 2 — sau khi trang thực sự hiện ra mới gắn ScrollTrigger.
    function start() {
        if (!canAnimate || !targets.length) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        var sequential = targets.filter(function (el) { return !isRepeatable(el); });
        var repeatable = targets.filter(isRepeatable);

        if (sequential.length) {
            ScrollTrigger.batch(sequential, {
                start: START,
                once: true,
                onEnter: show
            });
        }

        repeatable.forEach(function (el) {
            ScrollTrigger.create({
                trigger: el,
                start: START,
                onEnter: function () { show([el]); },
                onLeaveBack: function () { hide(el); }
            });
        });

        // Phần tử nằm sát đáy trang có thể không bao giờ chạm mốc 88% → hiện khi cuộn tới đáy.
        ScrollTrigger.create({
            trigger: document.documentElement,
            start: 'bottom bottom',
            onEnter: function () {
                show(targets.filter(function (el) {
                    return el.getBoundingClientRect().top < window.innerHeight;
                }));
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', prepare);
    } else {
        prepare();
    }

    window.qhOnPageReveal(start);
})();

/**
 * fadeInUp so le cho 1 nhóm phần tử bất kỳ — ảnh, thẻ card, item danh sách... (tên giữ "Images" vì
 * lịch sử, dùng được cho mọi phần tử).
 *
 * Cách 1 — khai báo trong .twig, không cần viết JS: gắn data-reveal-items lên khung danh sách,
 * các phần tử con TRỰC TIẾP sẽ hiện lần lượt khi cuộn tới:
 *   <ul class="news-list" data-reveal-items> <li>...</li> <li>...</li> </ul>
 *   <div class="gallery-module__grid" data-reveal-items> ... </div>
 *
 * Cách 2 — gọi bằng JS:
 *   window.qhRevealImages(target, options)
 *   target            — selector string, 1 phần tử, hoặc NodeList/mảng phần tử.
 *   options.trigger    — phần tử/selector làm mốc cuộn cho CẢ NHÓM (cả nhóm hiện cùng lúc, so le).
 *                         Bỏ trống → tự gom theo thời điểm vào khung nhìn (ScrollTrigger.batch): các
 *                         phần tử cùng hàng hiện cùng lượt, hàng sau hiện khi cuộn tới — hợp với lưới dài.
 *   options.start      — điểm bắt đầu trigger (mặc định 'top 85%').
 *   options.distance   — khoảng dịch chuyển trục Y, px (mặc định 40).
 *   options.duration   — thời lượng animation, giây (mặc định .8).
 *   options.stagger    — khoảng cách giữa các phần tử (mặc định .12).
 *   options.delay      — trễ thêm trước khi chạy, giây (mặc định 0).
 *   options.ease       — easing GSAP (mặc định 'power2.out').
 *   options.once       — chỉ chạy 1 lần (mặc định true). false → cuộn ngược lên trên thì ẩn lại,
 *                         cuộn xuống chạy lại.
 *
 *   VD: window.qhRevealImages('.product-list .product-card', { distance: 30, stagger: .1 });
 *   VD: window.qhRevealImages('.partner-logo', { trigger: '.partners' });
 *
 * Lưu ý để không bị giật:
 * - KHÔNG áp dụng cho phần tử nằm trong 1 khối cha cũng đang có hiệu ứng dịch chuyển (data-reveal,
 *   GSAP riêng...) — 2 chuyển động cộng dồn sẽ giật. Khối cha chỉ nên fade opacity, hoặc bỏ hẳn.
 * - Phần tử không nên có CSS transition trên transform/opacity (CSS sẽ "đuổi theo" GSAP từng frame).
 *   Hiệu ứng hover nên đặt lên phần tử con (VD hover scale cho <img> bên trong thẻ được reveal).
 *
 * - Ẩn sẵn ngay khi DOM sẵn sàng (preloader còn che), gắn ScrollTrigger sau qh:page-reveal.
 * - Mỗi phần tử chỉ khởi tạo 1 lần (gọi lặp không tạo animation trùng).
 * - Ảnh lazy-load xong làm đổi chiều cao → tự đo lại vị trí trigger (có gom nhóm).
 * - Tôn trọng prefers-reduced-motion và trường hợp thiếu GSAP (không ẩn gì, hiện ngay).
 */
window.qhRevealImages = (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canAnimate = !reduceMotion && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';
    var refreshTimer = null;

    function toArray(value) {
        if (typeof value === 'string') {
            return Array.prototype.slice.call(document.querySelectorAll(value));
        }
        if (!value) {
            return [];
        }
        return value.length !== undefined ? Array.prototype.slice.call(value) : [value];
    }

    function scheduleRefresh() {
        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(function () {
            ScrollTrigger.refresh();
        }, 150);
    }

    function whenDomReady(callback) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', callback);
        } else {
            callback();
        }
    }

    function whenPageRevealed(callback) {
        if (typeof window.qhOnPageReveal === 'function') {
            window.qhOnPageReveal(callback);
        } else {
            whenDomReady(callback);
        }
    }

    return function (target, options) {
        options = options || {};

        var distance = options.distance !== undefined ? options.distance : 40;
        var duration = options.duration || .8;
        var stagger = options.stagger !== undefined ? options.stagger : .12;
        var delay = options.delay || 0;
        var start = options.start || 'top 85%';
        var ease = options.ease || 'power2.out';
        var once = options.once !== false;

        var els = [];

        // distance = 0 (chỉ fade) → không đụng tới transform. Sau khi hiện xong xoá transform inline:
        // translate(0, 0) còn sót lại vẫn là transform ≠ none → biến phần tử thành containing block
        // cho position: fixed bên trong (modal/lightbox lệch vị trí) + tạo stacking context thừa.
        function hide(elements) {
            gsap.set(elements, distance ? { opacity: 0, y: distance } : { opacity: 0 });
        }

        function show(elements) {
            elements = window.qhRevealPassed(elements, distance ? { opacity: 1, clearProps: 'transform' } : { opacity: 1 });

            if (!elements.length) {
                return;
            }

            var vars = {
                opacity: 1,
                duration: duration,
                delay: delay,
                ease: ease,
                stagger: stagger,
                overwrite: 'auto' // chỉ huỷ tween trùng thuộc tính — true sẽ xoá cả tween khác (VD qhScrollRotate)
            };

            if (distance) {
                vars.y = 0;
                vars.clearProps = 'transform';
            }

            gsap.to(elements, vars);
        }

        // Bước 1 — ẩn sẵn khi DOM sẵn sàng (preloader còn che): nếu đợi tới lúc chạm mốc mới đặt
        // trạng thái ẩn, phần tử đang hiện sẽ bị giật về opacity 0 rồi mới hiện lại.
        function prepare() {
            if (!canAnimate) {
                return;
            }

            els = toArray(target).filter(function (el) {
                return !el.qhRevealItem;
            });

            els.forEach(function (el) {
                el.qhRevealItem = true;

                el.querySelectorAll('img').forEach(function (img) {
                    if (!img.complete) {
                        img.addEventListener('load', scheduleRefresh, { once: true });
                    }
                });
            });

            if (els.length) {
                hide(els);
            }
        }

        // Bước 2 — sau khi trang hiện ra mới gắn ScrollTrigger.
        function apply() {
            if (!canAnimate || !els.length) {
                return;
            }

            gsap.registerPlugin(ScrollTrigger);

            if (options.trigger) {
                ScrollTrigger.create({
                    trigger: options.trigger,
                    start: start,
                    once: once,
                    onEnter: function () { show(els); },
                    onLeaveBack: once ? null : function () { hide(els); }
                });
            } else {
                ScrollTrigger.batch(els, {
                    start: start,
                    once: once,
                    onEnter: show,
                    onLeaveBack: once ? null : hide
                });
            }
        }

        whenDomReady(prepare);
        whenPageRevealed(apply);
    };
})();

window.qhRevealImages('[data-reveal-items] > *');

/**
 * Fade-in (chỉ opacity, không dịch chuyển) cho mọi nội dung — text, ảnh, khối CMS...
 *
 * Cách 1 — gắn class trong .twig:
 *   <p class="aniFadeIn">Đoạn văn</p>                    → fade chính thẻ <p>
 *   <img class="aniFadeIn" src="..." alt="...">           → fade ảnh
 *   <div class="cms-content aniFadeIn">{{ content }}</div> → thẻ có phần tử con: fade LẦN LƯỢT
 *                                                            từng phần tử con trực tiếp (p, ul, figure...)
 *
 * Cách 2 — gọi bằng JS (nội dung chèn thêm bằng JS/AJAX...):
 *   window.qhFadeIn('.product-list .card', { duration: 1, stagger: .2 });
 *   options: duration (giây, mặc định 1), stagger (mặc định .15), delay (mặc định 0),
 *            start (mặc định 'top 88%'), once (mặc định true).
 *
 * - Phần tử đã nằm trong khung nhìn khi tải / reload trang sẽ fade-in ngay khi preloader mở màn;
 *   phần tử bên dưới fade-in khi cuộn tới. Nhiều phần tử vào khung nhìn cùng lúc hiện lần lượt.
 * - Chỉ lấy con TRỰC TIẾP (không phải mọi con cháu): cha và con cùng fade thì opacity nhân nhau,
 *   hiệu ứng chậm và nhoè. Cần fade sâu hơn thì gắn thêm aniFadeIn vào thẻ con đó.
 * - Thẻ có chữ nằm trực tiếp bên trong (không bọc thẻ) → fade cả thẻ, để chữ đó không bị bỏ sót.
 * - Không dùng chung với data-reveal / data-reveal-items / hiệu ứng opacity khác trên cùng phần tử.
 * - Dựa trên window.qhRevealImages (distance: 0): ẩn sẵn lúc preloader còn che, mỗi phần tử khởi tạo
 *   1 lần, tôn trọng prefers-reduced-motion / thiếu GSAP (không ẩn gì, hiện ngay).
 */
window.qhFadeIn = (function () {
    function toArray(value) {
        if (typeof value === 'string') {
            return Array.prototype.slice.call(document.querySelectorAll(value));
        }
        if (!value) {
            return [];
        }
        return value.length !== undefined ? Array.prototype.slice.call(value) : [value];
    }

    function hasLooseText(el) {
        return Array.prototype.some.call(el.childNodes, function (node) {
            return node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '';
        });
    }

    // Thẻ có phần tử con (và không có chữ rời) → các con trực tiếp; còn lại → chính thẻ đó.
    function expand(el) {
        var children = Array.prototype.filter.call(el.children, function (child) {
            return child.tagName !== 'SCRIPT' && child.tagName !== 'TEMPLATE';
        });

        return children.length && !hasLooseText(el) ? children : [el];
    }

    return function (target, options) {
        options = options || {};

        function run() {
            var elements = [];

            toArray(target).forEach(function (el) {
                expand(el).forEach(function (item) {
                    if (elements.indexOf(item) === -1) {
                        elements.push(item);
                    }
                });
            });

            if (!elements.length) {
                return;
            }

            window.qhRevealImages(elements, {
                distance: 0,
                duration: options.duration || 1,
                stagger: options.stagger !== undefined ? options.stagger : .15,
                delay: options.delay || 0,
                start: options.start || 'top 88%',
                ease: 'power1.out',
                once: options.once
            });
        }

        // Cần DOM đầy đủ để biết thẻ có con hay không.
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', run);
        } else {
            run();
        }
    };
})();

window.qhFadeIn('.aniFadeIn');

/**
 * Parallax dùng chung cho ảnh — ảnh trượt chậm hơn tốc độ cuộn bên trong khung chứa nó.
 * Dùng GSAP ScrollTrigger (scrub), đã nạp sẵn toàn site — không cần Rellax, không cần CSS riêng.
 *
 * Cách 1 — khai báo trong .twig (tự khởi tạo khi DOM sẵn sàng):
 *   <div class="khung-anh"><img src="..." data-parallax></div>
 *   <img ... data-parallax data-parallax-amount="0.15">            biên độ riêng
 *   <img ... data-parallax data-parallax-frame=".card__media">      khung = thẻ cha gần nhất khớp selector
 *   <picture data-parallax="hero" data-parallax-frame=".banner__inner">  banner đầu trang (xem dưới)
 *
 * Cách 2 — gọi bằng JS (ảnh chèn thêm bằng JS, script riêng của 1 trang...):
 *   window.qhParallax('.gallery img', { amount: .12 });
 *
 *   target          — selector string, 1 phần tử, hoặc NodeList/mảng phần tử.
 *   options.amount  — biên độ trượt theo tỉ lệ chiều cao ảnh, 0–0.3 (mặc định .1 = ±10%).
 *   options.frame   — selector khung chứa (closest). Bỏ trống = thẻ cha trực tiếp của ảnh.
 *   options.mode    — 'hero' cho banner/khối nằm ngay đầu trang (hoặc data-parallax="hero"):
 *                     độ dịch = 0 ở đầu trang, cuộn xuống ảnh trượt xuống theo amount × chiều cao
 *                     (mặc định .3, tối đa .6). Không phóng to ảnh. Phần tử phải là block (VD
 *                     <picture> cần display: block) — transform không có tác dụng với phần tử inline.
 *
 * Yêu cầu markup: ảnh phải phủ kín khung (width/height 100% + object-fit: cover, hoặc khung ôm
 * sát ảnh). Hàm tự set overflow: hidden cho khung và phóng ảnh lên đúng scale = 1 + 2 × amount
 * → biên độ trượt luôn nằm trong phần dư do phóng to, KHÔNG BAO GIỜ hở viền dù khung cao/thấp.
 *
 * - Độ dịch = 0 khi khung ở giữa màn hình, đổi dấu khi khung ở đầu/cuối màn hình.
 * - Khởi tạo ngay khi DOM sẵn sàng (preloader còn che) để ảnh above-the-fold không bị "nhảy"
 *   scale lúc trang hiện ra. Mỗi ảnh chỉ khởi tạo 1 lần (gọi lặp lại không sao).
 * - Ảnh lazy-load xong sẽ tự đo lại vị trí (ScrollTrigger.refresh, có gom nhóm).
 * - Tôn trọng prefers-reduced-motion và trường hợp thiếu GSAP: không làm gì, ảnh hiển thị tĩnh.
 */
window.qhParallax = (function () {
    var MAX_AMOUNT = .3;
    var DEFAULT_AMOUNT = .1;
    var MAX_HERO_AMOUNT = .6;
    var DEFAULT_HERO_AMOUNT = .3;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canAnimate = !reduceMotion && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';
    var refreshTimer = null;

    function toArray(value) {
        if (typeof value === 'string') {
            return Array.prototype.slice.call(document.querySelectorAll(value));
        }
        if (!value) {
            return [];
        }
        return value.length !== undefined ? Array.prototype.slice.call(value) : [value];
    }

    // Gom nhiều ảnh lazy-load xong gần nhau thành 1 lần refresh (refresh đo lại toàn bộ trigger).
    function scheduleRefresh() {
        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(function () {
            ScrollTrigger.refresh();
        }, 150);
    }

    function setup(img, options) {
        if (img.qhParallax) {
            return;
        }

        var frameSelector = options.frame || img.getAttribute('data-parallax-frame');
        var frame = frameSelector ? img.closest(frameSelector) : img.parentElement;

        if (!frame) {
            return;
        }

        var hero = (options.mode || img.getAttribute('data-parallax')) === 'hero';

        var amount = parseFloat(options.amount !== undefined ? options.amount : img.getAttribute('data-parallax-amount'));
        amount = isNaN(amount) ? (hero ? DEFAULT_HERO_AMOUNT : DEFAULT_AMOUNT) : Math.min(hero ? MAX_HERO_AMOUNT : MAX_AMOUNT, Math.max(0, amount));

        if (!amount) {
            return;
        }

        img.qhParallax = true;

        if (getComputedStyle(frame).overflow === 'visible') {
            frame.style.overflow = 'hidden';
        }

        if (hero) {
            // Hero (banner đầu trang): đứng yên ở scrollY = 0, cuộn xuống thì trượt xuống chậm hơn tốc độ
            // cuộn. Phần hở do trượt luôn nằm ở mép trên khung — đã cuộn ra khỏi màn hình → không cần scale.
            gsap.fromTo(img, {
                yPercent: 0
            }, {
                yPercent: amount * 100,
                ease: 'none',
                scrollTrigger: {
                    trigger: frame,
                    start: 'top top',
                    end: 'bottom top',
                    scrub: true
                }
            });
        } else {
            // yPercent tính theo chiều cao ảnh TRƯỚC khi scale → trượt ±amount nằm gọn trong phần dư
            // (scale - 1) / 2 = amount mỗi phía.
            gsap.fromTo(img, {
                yPercent: -amount * 100,
                scale: 1 + amount * 2
            }, {
                yPercent: amount * 100,
                ease: 'none',
                scrollTrigger: {
                    trigger: frame,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true
                }
            });
        }

        if (img.tagName === 'IMG' && !img.complete) {
            img.addEventListener('load', scheduleRefresh, { once: true });
        }
    }

    function init(target, options) {
        if (!canAnimate) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        toArray(target).forEach(function (img) {
            setup(img, options || {});
        });
    }

    return function (target, options) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function () {
                init(target, options);
            });
        } else {
            init(target, options);
        }
    };
})();

window.qhParallax('[data-parallax]');

/**
 * Xoay theo cuộn trang — cho họa tiết trang trí (chấm, vòng tròn, shape nền...).
 * Góc xoay gắn với vị trí cuộn (ScrollTrigger scrub): cuộn xuống xoay thuận chiều kim đồng hồ,
 * cuộn lên tự xoay ngược lại — không cần bắt hướng cuộn.
 *
 * Cách 1 — gắn attribute trong .twig:
 *   <span class="trans" data-scroll-rotate></span>          xoay tổng 30° khi cuộn qua phần tử
 *   <span class="dot" data-scroll-rotate="-60"></span>       số âm = đảo chiều, tối đa ±360
 *
 * Cách 2 — gọi bằng JS: window.qhScrollRotate('.deco', { degrees: 45 });
 *
 * - Góc chạy từ -degrees/2 (phần tử vừa vào từ đáy màn hình) tới +degrees/2 (vừa ra khỏi đỉnh)
 *   → ở giữa màn hình gần như thẳng.
 * - Chỉ dùng transform (rotation) nên chạy được cùng aniFadeIn / qhRevealImages chế độ chỉ fade
 *   (không đụng transform). KHÔNG dùng chung với hiệu ứng có dịch chuyển (y) trên cùng phần tử.
 * - Phần tử phải là block/inline-block (transform không tác dụng với phần tử inline).
 * - Tôn trọng prefers-reduced-motion và trường hợp thiếu GSAP: đứng yên.
 */
window.qhScrollRotate = (function () {
    var DEFAULT_DEGREES = 30;
    var MAX_DEGREES = 360;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canAnimate = !reduceMotion && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';

    function toArray(value) {
        if (typeof value === 'string') {
            return Array.prototype.slice.call(document.querySelectorAll(value));
        }
        if (!value) {
            return [];
        }
        return value.length !== undefined ? Array.prototype.slice.call(value) : [value];
    }

    function setup(el, options) {
        if (el.qhScrollRotate) {
            return;
        }

        var degrees = parseFloat(options.degrees !== undefined ? options.degrees : el.getAttribute('data-scroll-rotate'));
        degrees = isNaN(degrees) ? DEFAULT_DEGREES : Math.max(-MAX_DEGREES, Math.min(MAX_DEGREES, degrees));

        if (!degrees) {
            return;
        }

        el.qhScrollRotate = true;

        gsap.fromTo(el, {
            rotation: -degrees / 2
        }, {
            rotation: degrees / 2,
            ease: 'none',
            scrollTrigger: {
                trigger: el,
                start: 'top bottom',
                end: 'bottom top',
                scrub: .8 // quán tính nhẹ → xoay mềm, không bám cứng từng pixel cuộn
            }
        });
    }

    return function (target, options) {
        function run() {
            if (!canAnimate) {
                return;
            }

            gsap.registerPlugin(ScrollTrigger);

            toArray(target).forEach(function (el) {
                setup(el, options || {});
            });
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', run);
        } else {
            run();
        }
    };
})();

window.qhScrollRotate('[data-scroll-rotate]');
